<template>
	<div class="markdown-body" v-markdown="value"></div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class MarkdownText extends Vue {
	@Prop() public value!: string;
}
</script>

<style lang="stylus">
@import '~variables'

.markdown-body
	-ms-text-size-adjust 100%
	-webkit-text-size-adjust 100%
	line-height 1.3
	font-size 1em
	word-wrap break-word

	p, blockquote, ul, ol, dl, table, pre
		margin-top 0
		margin-bottom 1.6em

	a
		color: $secondary
		&:not([href])
			text-decoration none

	strong
		font-weight bolder

	img
		border-style none
		max-width 100%
		box-sizing content-box

	hr
		box-sizing content-box
		height 0
		overflow visible
		height 0
		margin 1.5em 0
		overflow hidden
		background transparent
		border 0
		height 0.25em
		padding 0
		margin 2.4em 0
		border 0
		&::before
			display table
			content ""
		&::after
			display table
			clear both
			content ""

	table
		border-spacing 0
		border-collapse collapse
		width 100%
		th
			text-align left
			font-weight 600
		th td
			padding 6px 13px

	h1, h2, h3, h4, h5, h6
		margin-top 0
		margin-bottom 0
		font-weight 600
		line-height 1.25
		:hover .anchor
			text-decoration none
	h1
		font-size 2em
		margin 0.67em 0
	h2
		font-size 1.5em
		margin 0.33em 0
	h3
		font-size 1.25em
	h4
		font-size 1em
	h5
		font-size 0.875em
	h6
		font-size 0.85em
	p
		margin-top 0
		margin-bottom 1rem

	blockquote
		font-size 1em
		margin 1em 0
		padding 0 1em
		& > :first-child
			margin-top 0
		& > :last-child
			margin-bottom 0

	dd
		margin-left 0

	code
		font-family monospace, monospace
		font-size 12px
		padding 0.2em 0.4em
		margin 0
		font-size 85%
		border-radius 3px

	pre
		font-family monospace, monospace
		margin-top 0
		margin-bottom 0
		font-size 12px
		word-wrap normal
		padding 16px
		overflow auto
		font-size 85%
		line-height 1.45
		border-radius 3px
		& > code
			padding 0
			margin 0
			font-size 100%
			word-break normal
			white-space pre
			background transparent
			border 0
		code
			display inline
			max-width auto
			padding 0
			margin 0
			overflow visible
			line-height inherit
			word-wrap normal
			background-color transparent
			border 0

	li
		word-wrap break-all
		& > p
			margin-top 16px
		& + li
			margin-top 0.25em

	dl
		padding 0
		dt
			padding 0
			margin-top 16px
			font-size 1em
			font-style italic
			font-weight 600
		dd
			padding 0 16px
			margin-bottom 16px

	img[align=right]
		padding-left 20px

	img[align=left]
		padding-right 20px

	ul, ol
		margin 1em 0
		padding 0
		padding-left 2em
		ol
			list-style-type lower-roman
		ul, ol
			margin-top 0
			margin-bottom 0
			ol
				list-style-type lower-alpha

	*
		box-sizing border-box

	&::before
		display table
		content ""

	&::after
		display table
		clear both
		content ""

</style>
